module.exports = __webpack_public_path__ + "img/activeSet2.0751dd95.png";